module.exports = __webpack_public_path__ + "img/phone.4d31af58.png";